import type { MenuAvailability } from '@wix/restaurants-olo-operations-client-commons';

import type { DispatchType } from '../../types/businessTypes';
import type {
  MenuItem,
  MenuSectionAvailability,
  PopulatedMenu,
} from '../../types/menu';
import type {
  MenuAvailabilityStatusById,
  SectionAvailabilityStatusById,
} from '../../types/menuAvailability';

import type {
  ItemAvailabilityByPlacementId,
  SelectedTimeSlot,
} from './availabilityTypes';
import { getResolvedItemAvailability } from './timeSlotAvailability';

export const getItemAvailabilityPlacementId = (
  menuId: string,
  sectionId: string,
  itemId: string,
) => `${menuId}:${sectionId}:${itemId}`;

export const buildItemAvailabilityByPlacementId = ({
  menus,
  itemMap,
  menuAvailabilityById = {},
  menuAvailabilityStatusById = {},
  sectionAvailabilityById = {},
  sectionAvailabilityStatusById = {},
  selectedTimeSlot,
  selectedDispatchType,
  timezone,
}: {
  menus: PopulatedMenu[];
  itemMap: Record<string, MenuItem>;
  menuAvailabilityById?: Record<string, MenuAvailability>;
  menuAvailabilityStatusById?: MenuAvailabilityStatusById;
  sectionAvailabilityById?: Partial<Record<string, MenuSectionAvailability>>;
  sectionAvailabilityStatusById?: SectionAvailabilityStatusById;
  selectedTimeSlot?: SelectedTimeSlot | null;
  selectedDispatchType?: DispatchType;
  timezone?: string;
}): ItemAvailabilityByPlacementId => {
  return menus.reduce<ItemAvailabilityByPlacementId>((acc, menu) => {
    menu.sections.forEach((section) => {
      section.itemIds.forEach((itemId) => {
        const item = itemMap[itemId];

        if (!item) {
          return;
        }

        acc[getItemAvailabilityPlacementId(menu.id, section.id, itemId)] =
          getResolvedItemAvailability({
            item,
            menuAvailability: menuAvailabilityById[menu.id],
            menuAvailabilityStatus: menuAvailabilityStatusById[menu.id],
            sectionAvailability: sectionAvailabilityById[section.id],
            sectionAvailabilityStatus:
              sectionAvailabilityStatusById[section.id],
            selectedTimeSlot,
            selectedDispatchType,
            timezone,
          });
      });
    });

    return acc;
  }, {});
};
